function Fields2(){
	if ($('.fields-index-search.v2').length)
		this.init();
}

Fields2.prototype.init = function(){
	var self = this;
	self.initParams = 0;
	self.initLabel = 0;
	//console.log('inicjacja wyszukiwarki V2');
	this.showDropdownAfterDegree();
	
	var step = 1;
	// sprawdzanie kroku

	// if ($('.select-dropdown-element.city.-active').length)
	// 	step = 2;

	// if ($('.select-dropdown-element.degree_type.-active').length)
	// 	step = 3;

	// if ($('.select-dropdown-element.form.-active').length)
	// 	step = 4;

	//conslole.log('Step = ' + step);
	if ($('.fields-index-search.v2').length)
	 	this.updateInputs(step);
};

Fields2.prototype.setInitParams = function() {
	var self = this;
	if ($(".fields-index-search.v2").attr('data-init') && self.initParams==0) {
		var init = JSON.parse( $(".fields-index-search.v2").attr('data-init') );
		console.log('initParams');
		if (init.field)
			this.field = init.field;
		if (init.department)
			this.department = init.department;
		if (init.degree)
			this.level = init.degree;
		if (init.degree_type)
			this.degree_type = init.degree_type;
		if (init.form)
			this.form = init.form;
		if (init.lang_code)
			this.lang_code = init.lang_code;
		this.initParams = 1;
	}
};

Fields2.prototype.initLabelSelect = function() {
	var self = this;
	if ($(".fields-index-search.v2").attr('data-init')) {
		var init = JSON.parse( $(".fields-index-search.v2").attr('data-init') );
		//console.log(init);
		if (init.field) {
			this.field = init.field;
			$('#kierunek-label').html( $(".fields-index-search.v2 .dropdown-input-container[data-step='1'] .select-dropdown-element[data-field="+init.field+"]").html() );
		}
		if (init.department) {
			this.department = init.department;
			$('#wydzial-label').html( $(".fields-index-search.v2 .dropdown-input-container[data-step='3'] .select-dropdown-element[data-department="+init.department+"]").html() );
		}
		if (init.degree) {
			this.level = init.degree;
			$('#poziom-label').html( $(".fields-index-search.v2 .dropdown-input-container[data-step='4'] .select-dropdown-element[data-level="+init.degree+"]").html() );
		}
		if (init.degree_type) {
			this.degree_type = init.degree_type;
			$('#zakres-label').html( $(".fields-index-search.v2 .dropdown-input-container[data-step='5'] .select-dropdown-element[data-degree_type="+init.degree_type+"]").html() );
		}
		if (init.form) {
			this.form = init.form;
			$('#tryb-label').html( $(".fields-index-search.v2 .dropdown-input-container[data-step='6'] .select-dropdown-element[data-form="+init.form+"]").html() );
		}
		if (init.lang_code) {
			this.lang_code = init.lang_code;
			$('#lang_code-label').html( $(".fields-index-search.v3 .dropdown-input-container[data-step='2'] .select-dropdown-element[data-form="+init.lang_code+"]").html() );
		}
	}
	this.initLabel = 1;
	self.link = self.prefix_url+'/search-fields2?field='+self.field+'&department='+self.department+'&level='+self.level+'&degree_type='+self.degree_type+'&form='+self.form+'&lang_code='+self.lang_code;
	$('.fields-index-search.v2 .submit-container').find('.submit').attr('href', self.link);
};

Fields2.prototype.showDropdownAfterDegree = function() {
	var self = this;

	self.prefix_url = '';
	self.lang = lang;
	if (self.lang=='en')
		self.prefix_url = "/"+lang;
	
	self.field = $(".fields-index-search.v2 .dropdown-input-container[data-step='1'] .select-dropdown-element.-active").length ? $(".fields-index-search.v2 .dropdown-input-container[data-step='1'] .select-dropdown-element.-active").attr('data-field') : '';
	self.department = $(".fields-index-search.v2 .dropdown-input-container[data-step='3'] .select-dropdown-element.-active").length ? $(".fields-index-search.v2 .dropdown-input-container[data-step='3'] .select-dropdown-element.-active").attr('data-department') : '';
	self.level = $(".fields-index-search.v2 .dropdown-input-container[data-step='4'] .select-dropdown-element.-active").length ? $(".fields-index-search.v2 .dropdown-input-container[data-step='4'] .select-dropdown-element.-active").attr('data-level') : '';
	self.degree_type = $(".fields-index-search.v2 .dropdown-input-container[data-step='5'] .select-dropdown-element.-active").length ? $(".fields-index-search.v2 .dropdown-input-container[data-step='5'] .select-dropdown-element.-active").attr('data-degree_type') : '';
	self.form = $(".fields-index-search.v2 .dropdown-input-container[data-step='6'] .select-dropdown-element.-active").length ? $(".fields-index-search.v2 .dropdown-input-container[data-step='6'] .select-dropdown-element.-active").attr('data-form') : '';
	self.lang_code = $(".fields-index-search.v3 .dropdown-input-container[data-step='2'] .select-dropdown-element.-active").length ? $(".fields-index-search.v3 .dropdown-input-container[data-step='2'] .select-dropdown-element.-active").attr('data-form') : '';
	
	self.setInitParams();

	$(".fields-index-search.v2 .dropdown-input-container[data-step='1'] .select-dropdown-element").on('click keydown', function(e){
		if (e.type === 'click' || ['Enter'].includes(e.key)) {
			e.preventDefault();

			var step = parseInt($(e.target).closest('.dropdown-input-container').attr('data-step'));

			self.field = $(e.target).attr('data-field');

			self.resetInput([2, 3, 4, 5, 6]);
			self.updateInputs(step);

			self.link = self.prefix_url+'/search-fields2?field='+self.field+'&department='+self.department+'&level='+self.level+'&degree_type='+self.degree_type+'&form='+self.form+'&lang_code='+self.lang_code;
			$(this).closest('.dropdown-input-container').siblings('.submit-container').find('.submit').text(searchTranslate[self.lang].btn);
			$(this).closest('.dropdown-input-container').siblings('.submit-container').find('.submit').attr('href', self.link);
		}
	});

	$(".fields-index-search.v2 .dropdown-input-container[data-step='2'] .select-dropdown-element").on('click keydown', function(e){
		if (e.type === 'click' || ['Enter'].includes(e.key)) {
			e.preventDefault();

			var step = parseInt($(e.target).closest('.dropdown-input-container').attr('data-step'));

			self.lang_code = $(e.target).attr('data-lang_code');

			self.resetInput([3, 4, 5, 6]);
			self.updateInputs(step);

			self.link = self.prefix_url+'/search-fields2?field='+self.field+'&department='+self.department+'&level='+self.level+'&degree_type='+self.degree_type+'&form='+self.form+'&lang_code='+self.lang_code;
			$(this).closest('.dropdown-input-container').siblings('.submit-container').find('.submit').text(searchTranslate[self.lang].btn);
			$(this).closest('.dropdown-input-container').siblings('.submit-container').find('.submit').attr('href', self.link);
		}
	});

	$('body').on('click keydown', '.fields-index-search.v2 .dropdown-input-container[data-step="3"] .select-dropdown-element', function(e){
		if (e.type === 'click' || ['Enter'].includes(e.key)) {
			e.preventDefault();

			var step = parseInt($(e.target).closest('.dropdown-input-container').attr('data-step'));
			//console.log(step);

			self.department = $(e.target).attr('data-department');

			self.resetInput([4, 5, 6]);
			self.updateInputs(step);

			self.link = self.prefix_url+'/search-fields2?field='+self.field+'&department='+self.department+'&level='+self.level+'&degree_type='+self.degree_type+'&form='+self.form+'&lang_code='+self.lang_code;
			$(this).closest('.dropdown-input-container').siblings('.submit-container').find('.submit').text(searchTranslate[self.lang].btn);
			$(this).closest('.dropdown-input-container').siblings('.submit-container').find('.submit').attr('href', self.link);
		}
	});

	$('body').on('click keydown', '.fields-index-search.v2 .dropdown-input-container[data-step="4"] .select-dropdown-element', function(e){
		if (e.type === 'click' || ['Enter'].includes(e.key)) {
			e.preventDefault();

			var step = parseInt($(e.target).closest('.dropdown-input-container').attr('data-step'));
			//console.log(step);

			//self.field = $(e.target).attr('data-field');
			self.level = $(e.target).attr('data-level');

			self.resetInput([5, 6]);
			self.updateInputs(step);

			self.link = self.prefix_url+'/search-fields2?field='+self.field+'&department='+self.department+'&level='+self.level+'&degree_type='+self.degree_type+'&form='+self.form+'&lang_code='+self.lang_code;
			$(this).closest('.dropdown-input-container').siblings('.submit-container').find('.submit').text(searchTranslate[self.lang].btn);
			$(this).closest('.dropdown-input-container').siblings('.submit-container').find('.submit').attr('href', self.link);
		}
	});

	$('body').on('click keydown', '.fields-index-search.v2 .dropdown-input-container[data-step="5"] .select-dropdown-element', function(e){
		if (e.type === 'click' || ['Enter'].includes(e.key)) {
			e.preventDefault();

			var step = parseInt($(e.target).closest('.dropdown-input-container').attr('data-step'));
			//console.log(step);

			self.degree_type = $(e.target).attr('data-degree_type');

			self.resetInput([6]);
			self.updateInputs(step);

			self.link = self.prefix_url+'/search-fields2?field='+self.field+'&department='+self.department+'&level='+self.level+'&degree_type='+self.degree_type+'&form='+self.form+'&lang_code='+self.lang_code;
			$(this).closest('.dropdown-input-container').siblings('.submit-container').find('.submit').text(searchTranslate[self.lang].btn);
			$(this).closest('.dropdown-input-container').siblings('.submit-container').find('.submit').attr('href', self.link);
		}
	});

	$('body').on('click keydown', '.fields-index-search.v2 .dropdown-input-container[data-step="6"] .select-dropdown-element', function(e){
		if (e.type === 'click' || ['Enter'].includes(e.key)) {
			e.preventDefault();

			var step = parseInt($(e.target).closest('.dropdown-input-container').attr('data-step'));
			//console.log(step);

			self.form = $(e.target).attr('data-form');

			self.updateInputs(step);

			self.link = self.prefix_url+'/search-fields2?field='+self.field+'&department='+self.department+'&level='+self.level+'&degree_type='+self.degree_type+'&form='+self.form+'&lang_code='+self.lang_code;
			$(this).closest('.dropdown-input-container').siblings('.submit-container').find('.submit').text(searchTranslate[self.lang].btn);
			$(this).closest('.dropdown-input-container').siblings('.submit-container').find('.submit').attr('href', self.link);
		}
	});
	
};

Fields2.prototype.updateInputs = function(clicked_step) {
	var self = this;
	
	var _data = {'field':self.field,'department':self.department,'level':self.level,'degree_type':self.degree_type,'form':self.form ,'lang_code':self.lang_code};

	switch (clicked_step) {
		case 1:
			$('.fields-index-search.v2 .dropdown-input-container[data-step="2"]').addClass('-disabled');
			$('.fields-index-search.v2 .dropdown-input-container[data-step="3"]').addClass('-disabled');			
			$('.fields-index-search.v2 .dropdown-input-container[data-step="4"]').addClass('-disabled');
			$('.fields-index-search.v2 .dropdown-input-container[data-step="5"]').addClass('-disabled');
			$('.fields-index-search.v3 .dropdown-input-container[data-step="6"]').addClass('-disabled');
			break;
		case 2:
			$('.fields-index-search.v2 .dropdown-input-container[data-step="3"]').addClass('-disabled');			
			$('.fields-index-search.v2 .dropdown-input-container[data-step="4"]').addClass('-disabled');
			$('.fields-index-search.v2 .dropdown-input-container[data-step="5"]').addClass('-disabled');
			$('.fields-index-search.v3 .dropdown-input-container[data-step="6"]').addClass('-disabled');
			break;
		case 3:				
			$('.fields-index-search.v2 .dropdown-input-container[data-step="4"]').addClass('-disabled');
			$('.fields-index-search.v2 .dropdown-input-container[data-step="5"]').addClass('-disabled');
			$('.fields-index-search.v3 .dropdown-input-container[data-step="6"]').addClass('-disabled');
			break;
		case 4:
			$('.fields-index-search.v2 .dropdown-input-container[data-step="5"]').addClass('-disabled');
			$('.fields-index-search.v2 .dropdown-input-container[data-step="6"]').addClass('-disabled');
			break;
		case 5:
			$('.fields-index-search.v2 .dropdown-input-container[data-step="6"]').addClass('-disabled');
			break;
		case 6:
				
			break;
	}

	$('.fields-index-search.v2 .submit').addClass('-disabled').attr('tabindex', '-1');

	if (typeof self.xhr !== 'undefined')
		self.xhr.abort();

	self.xhr = $.ajax({
		type        : 'POST',
		url         : self.prefix_url+'/search-fields2',
		data        : _data,
		dataType    : 'json',
	}).done(function(data) {

		if (clicked_step<=1) {
			//jezyk
			$('.fields-index-search.v3 .dropdown-input-container[data-step="2"]').find('.select-dropdown-element').remove();
			var langHtml = '';
			$.each(data.lang_code, function(i, v) {
				langHtml += '<button class="select-dropdown-element lang_code -exists" data-lang_code="'+v.id+'">'+v.title+'</button>';
			});
			//console.log('Jezyk');
			//console.log(langHtml);
			$('.fields-index-search.v3 .dropdown-input-container[data-step="2"]').find('.select-dropdown-background').append(langHtml);
			$('.fields-index-search.v3 .dropdown-input-container[data-step="2"]').removeClass('-disabled');
		}

		if (clicked_step<=2) {
			//wydzial
			$('.fields-index-search.v2 .dropdown-input-container[data-step="3"]').find('.select-dropdown-element').remove();
			var departmentHtml = '';
			$.each(data.departments, function(i, v) {
				departmentHtml += '<button class="select-dropdown-element department -exists" data-department="'+v.id+'">'+v.title+'</button>';
			});
			$('.fields-index-search.v2 .dropdown-input-container[data-step="3"]').find('.select-dropdown-background').append(departmentHtml);
			$('.fields-index-search.v2 .dropdown-input-container[data-step="3"]').removeClass('-disabled');
		}

		if (clicked_step<=3) {
			//poziom
			$('.fields-index-search.v2 .dropdown-input-container[data-step="4"]').find('.select-dropdown-element').remove();
			var levelHtml = '';
			$.each(data.levels, function(i, v) {
				levelHtml += '<button class="select-dropdown-element level -exists" data-level="'+v.id+'">'+v.title+'</button>';
			});
			$('.fields-index-search.v2 .dropdown-input-container[data-step="4"]').find('.select-dropdown-background').append(levelHtml);
			$('.fields-index-search.v2 .dropdown-input-container[data-step="4"]').removeClass('-disabled');
		}

		if (clicked_step<=4) {
			//zakres
			$('.fields-index-search.v2 .dropdown-input-container[data-step="5"]').find('.select-dropdown-element').remove();
			var degree_typesHtml = '';
			$.each(data.degree_types, function(i, v) {
				degree_typesHtml += '<button class="select-dropdown-element degree_type -exists" data-degree_type="'+v.id+'">'+v.title+'</button>';
			});
			$('.fields-index-search.v2 .dropdown-input-container[data-step="5"]').find('.select-dropdown-background').append(degree_typesHtml);
			$('.fields-index-search.v2 .dropdown-input-container[data-step="5"]').removeClass('-disabled');
		}

		if (clicked_step<=5) {
			//form
			$('.fields-index-search.v2 .dropdown-input-container[data-step="6"]').find('.select-dropdown-element').remove();
			var formHtml = '';
			$.each(data.form, function(i, v) {
				formHtml += '<button class="select-dropdown-element form -exists" data-form="'+v.id+'">'+v.title+'</button>';
			});
			$('.fields-index-search.v2 .dropdown-input-container[data-step="6"]').find('.select-dropdown-background').append(formHtml);
			$('.fields-index-search.v2 .dropdown-input-container[data-step="6"]').removeClass('-disabled');
		}
		//self.resetInput([5]);
		
		$('.fields-index-search.v2 .dropdown-input-container').each(function() {
			if (!$(this).find('.select-dropdown-element.-exists').length) {
				$(this).addClass('-disabled').find('.select-box').attr('tabindex', '-1');
			} else {
				$(this).removeClass('-disabled').find('.select-box').attr('tabindex', '0');
			}
		});

		//inicjacja selectow
		if (self.initLabel==0) {
			self.initLabelSelect();
		}

		//console.log(data);
		if (Object.keys(data.chairs).length)
			$('.fields-index-search.v2 .submit').removeClass('-disabled').attr('tabindex', '0');
	});

};

Fields2.prototype.resetInput = function(inputs_arr) {
	var self = this;

	$.each(inputs_arr, function(i, v) {
		switch (v) {
			case 1:
				self.field = '';
				break;
			case 2:
				self.lang_code = '';
				break;
			case 3:
				self.department = '';
				break;
			case 4:
				self.level = '';
				break;
			case 5:
				self.degree_type = '';
				break;
			case 6:
				self.form = '';
				break;
		}

		$('.fields-index-search.v2 .dropdown-input-container[data-step="'+v+'"]').find('.select-box__text').text($('.dropdown-input-container[data-step="'+v+'"]').find('.select-box__text').attr('data-title'));
		$('.fields-index-search.v2 .dropdown-input-container[data-step="'+v+'"]').find('.select-dropdown-element.-active').removeClass('-active');
	});
};